<template>
  <UIModal v-model="isOpen" blured max-height @closed="emit('closed')">
    <!-- Header -->
    <template #header>
      <h2 class="modal__title">{{ $t('walletTokenAddressModalTitle') }}</h2>
    </template>

    <!-- Content -->
    <div class="modal__content">
      <p class="modal__description">{{ $t('walletTokenAddressModalDescription') }}</p>

      <TokenAddressCard
        v-for="token in tokens"
        :key="token.id"
        :is-processing="isProcessing"
        :token="token"
        @add="handleTokenAdd"
      />
    </div>
  </UIModal>
</template>

<script lang="ts" setup>
import { useWeb3ModalProvider } from '@web3modal/ethers/vue';
import type { ITokenModel } from '~/types/apiService';
import TokenAddressCard from './TokenAddressCard.vue';

const { addTokenToWallet } = useWalletMethods();
const { walletProvider } = useWeb3ModalProvider();

const isOpen = defineModel<boolean>({ default: false });

defineProps<{
  tokens: (ITokenModel & { balance: string })[];
}>();

const isProcessing = ref(false);

const handleTokenAdd = async (token: ITokenModel & { balance: string }): Promise<void> => {
  if (!walletProvider) {
    return;
  }

  const options = {
    address: token.tokenContractAddress,
    decimals: 18,
    image: `https://pearldivergame.com${(getIcon(0, token.tokenContractAddress) || '').replace('/_nuxt/public', '')}`
  };

  try {
    isProcessing.value = true;
    await addTokenToWallet(options);
  } finally {
    isProcessing.value = false;
  }
};

const emit = defineEmits(['closed']);
</script>

<style lang="scss" scoped>
.modal {
  &__title {
    font-family: Grenze;
    font-weight: 700;
    font-size: 32px;
    line-height: 100%;
    text-align: center;
    color: #ffffff;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0 16px 26px;
  }

  &__description {
    font-family: Grenze;
    font-weight: 500;
    font-size: 20px;
    line-height: 1.1;
    text-align: center;
    color: #90989d;
    margin: 0 auto 14px;
    max-width: 300px;
  }
}
</style>
